export const DASHBOARD = 'Tableau de bord';
export const USER = 'ROLE_PC_USER';
export const ADMINISTRATEUR = 'ROLE_ADMINISTRATEUR';
export const SUPER_ADMIN = 'ROLE_SUPER_ADMIN';
export const APPEL_OFFRE = 'ROLE_APPEL_OFFRE';
export const COMMERCIAL = 'ROLE_COMMERCIAL';
export const PROJET = 'ROLE_PROJET';
export const INTERVENTION = 'ROLE_INTERVENTION';
export const FORMATION = 'ROLE_FORMATION';
export const GESTION_PSY = 'ROLE_GESTION_PSY';
